/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone */

_.namespace(`mp.static.landing.marketing`, function(ns) {
  'use strict';
  ns.initMarketo = function() {
    ns.MarketoContactForm = new Backbone.widgets.ContactForm({
      $placement_el: $(`body`),
      contactFormHeaderType: `contact_form_popup_header`,
      contactFormFooterType: `contact_form_popup_footer`,
      // there are only two pages that will use this: "Pricing" and "Trends"
      marketo_form_name: window.location.pathname.match(/^\/pricing/) ? `custom_quote` : `contact_us`,
    });
  };
});

}.call(window));